<template>
  <div style="display:flex;flex-direction:column;height: 100%;">
    <div class="operations" style="margin-bottom: 5px">
      <div class="triggers">
        <div>
          <el-button
            no="showEditDialog"
            :disabled="readonly"
            type="primary"
            @click="()=>showEditDialog(true)"
          >{{ $t('common.btn.new') }}</el-button>
          <el-button
            no="showEditDialog"
            :disabled="readonly"
            type="primary"
            @click="()=>showEditDialog(false)"
          >{{ $t('common.btn.edit') }}</el-button>
          <el-button
            no="remove"
            :disabled="readonly"
            type="danger"
            @click="remove"
          >{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
    </div>
    <div class="grid-wrapper">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :side-bar="sideBarDefs"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('Partners.changeServicePersonnel')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row">
        <el-form label-width="90px" label-position="left">
          <!--岗位类型-->
          <el-form-item :label="$t('Partners.positionType')">
            <el-select v-model="editDialog.form.roleType" no="roleType" @change="roleTypeChange">
              <el-option
                v-for="(item,index) in roleTypes"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <!--业务类型-->
          <el-form-item :label="$t('Payment.businessType')">
            <el-select v-model="editDialog.form.lob" no="lob" @change="lobChange">
              <el-option :label="$t('SeaExport.All')" value="ALL" />
              <el-option
                v-for="(item,index) in lobs"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-show="showCargoSource" :label="$t('SeaExport.SolicitationType')">
            <el-select v-model="editDialog.form.cargoSource" no="cargoSource" :clearable="true">
              <el-option :label="$t('Partners.customerSpace2')" value="NC" />
              <el-option :label="$t('Partners.customerSpace3')" value="SC" />
            </el-select>
          </el-form-item>
          <!--用户名称-->
          <el-form-item :label="$t('Partners.userName')">
            <cargo-user-select
              ref="userSelect"
              no="userId"
              :method-params="{category:'role',shape:getRoleTypeEnglishName(editDialog.form.roleType)}"
              :default-value="editDialog.form.userId||''"
              style="width: 200px"
              :show-custom-label-in-option="true"
              :custom-label="userCustomLabel"
              :init-default-option="true"
              @change="p=>{editDialog.form.userId=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultUser" no="defaultUser">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="showCustomerExpandMode" :label="$t('CargoMsg.Cargo_CustomerExpandMode')">
            <el-select v-model="editDialog.form.customerExpandMode" no="customerExpandMode">
              <el-option
                v-for="(item,index) in customerExpandModes"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Payment.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="saveSub" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as CargoOfRoleTypeUtil from '@/class/cargo/model/utils/CargoOfRoleTypeUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import StrUtils from '@/utils/StrUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { Company } from '@/class/model/mdm/Company'
import { OP_TYPE, OVERSEAOP_TYPE } from '@/class/cargo/model/parameters/CargoOfRoleType'

export default {
  name: 'CompanyUserContainer',
  components: { cargoAdvanceSelect, cargoUserSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      lobs: [],
      roleTypes: [],
      customerExpandModes: [], // 太平-拓客方式
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: this.$t('Partners.positionType'),
          field: 'roleType',
          width: 150,
          cellRenderer: params => {
            return this.roleTypeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Payment.businessType'),
          field: 'lob',
          width: 150,
          cellRenderer: params => {
            return this.jobBussStateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Tool.User'),
          field: 'userId',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultUser',
          width: 100,
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        }, {
          headerName: this.$t('Payment.remarks'),
          field: 'remarks',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomerExpandMode'), field: 'customerExpandMode', initialWidth: 140,
          cellRenderer: params => {
            return ColumnUtils.CustomerExpandModesLabelFun(params.value)
          }
        },
        { headerName: this.$t('SystemMaintenance.CreationDate'), field: 'dateCreated', initialWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SystemMaintenance.ModificationDate'), field: 'dateModified', initialWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      editDialog: {
        visible: false,
        form: {
          companyUuid: '',
          roleType: '',
          lob: '',
          userId: '',
          defaultUser: false,
          remarks: '',
          cargoSource: '',
          customerExpandMode: ''
        },
        initForm: {
          companyUuid: '',
          roleType: '',
          lob: '',
          userId: '',
          defaultUser: false,
          remarks: '',
          cargoSource: '',
          customerExpandMode: ''
        }
      },
      partner: null,
      isXy: false,
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  computed: {
    readonly() {
      return !this.action || this.action === 'look'
    },
    isZh() {
      return this.$i18n.locale === 'zh'
    },
    showCargoSource() {
      return [CargoOfRoleType.SALES_TYPE.code, CargoOfRoleType.SALES_OF_GOODS.code, CargoOfRoleType.OP_TYPE.code, CargoOfRoleType.OVERSEAOP_TYPE.code].indexOf(this.editDialog.form.roleType) === -1 &&
        this.editDialog.form.lob === 'SE'
    },
    showCustomerExpandMode() {
      return this.editDialog.form.roleType === CargoOfRoleType.SALES_TYPE.code
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isXy = String(cache.config.get('ToExoSystem')) === 'XYCW'
    this.lobs = SystemConstants.FBA_LOBS
    this.roleTypes = await CargoOfRoleTypeUtil.getCompanyUserRoleTypes()
    this.customerExpandModes = SystemConstants.CUSTOMER_EXPAND_MODES
  },
  methods: {
    async onshow(row) {
      this.partner = row
      this.query()
    },
    async remove() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await this.$confirm(this.$t('common.tips.confirmDelete'))
      const index = this.rowData.findIndex(p => p.seq === row.seq)
      this.rowData.splice(index, 1)
      if (row.uuid) {
        this.partner.deletedCompanyUserKeys.push(row.uuid)
      }
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          seq: this.autoIncrementNum.getNextNum(),
          ...this.editDialog.initForm
        }
        if (this.isXy) {
          this.editDialog.form.lob = 'ALL'
          this.editDialog.form.defaultUser = true
        }
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        const cell = this.gridApi.getFocusedCell()
        const row = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
      }
      this.editDialog.visible = true
    },
    getRoleTypeEnglishName(val) {
      const roleType = CargoOfRoleType.getCargoOfRoleTypeByCode(val)
      if (roleType) {
        return roleType.englishName
      } else {
        return '-'
      }
    },
    selectEditCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    async saveSub() {
      const form = this.editDialog.form
      form.companyUuid = this.partner.uuid
      // CARGO-41087 合作伙伴-新增服务人员时，若没有选择业务类型，直接保存时，lob值存空
      form.lob = form.lob || 'ALL'
      const check = await this.checkCompanyUser(form)
      if (!check) return
      const row = this.rowData.find(item => item.seq === form.seq)
      let rollbackPersistMain = null
      if (row) {
        const prev = { ...row }
        Object.assign(row, form)
        rollbackPersistMain = () => Object.assign(row, prev)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
        rollbackPersistMain = () => {
          const idx = this.rowData.findIndex(r => r.seq === form.seq)
          if (idx >= 0) {
            this.rowData.splice(idx, 1)
          }
        }
      }
      const supervisorOk = await this.appendPartnerCsrSupervisorRow(form)
      if (!supervisorOk) {
        rollbackPersistMain()
        return
      }
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
      this.editDialog.visible = false
    },

    /** SYS_CONFIG_DEF.NAME PartnerCustomerCsrSupervisorUserId；≤0 或未配置则关闭 */
    getPartnerCsrSupervisorUserId() {
      const n = Number(cache.config.get('PartnerCustomerCsrSupervisorUserId'))
      return Number.isFinite(n) && n > 0 ? n : 0
    },

    /**
     * 岗位为客服时自动追加客服主管一行；已选主管本人或表中已有同 lob 客服记录则跳过。
     * 校验失败返回 false（调用方需回滚已写入的主行）。
     */
    async appendPartnerCsrSupervisorRow(mainForm) {
      if (mainForm.roleType !== CargoOfRoleType.CSR_TYPE.code) {
        return true
      }
      const supervisorUserId = this.getPartnerCsrSupervisorUserId()
      if (!supervisorUserId) {
        return true
      }
      const lobNorm = mainForm.lob || 'ALL'
      if (this.samePartnerUserId(mainForm.userId, supervisorUserId)) {
        return true
      }
      const exists = this.rowData.some(r =>
        this.samePartnerUserId(r.userId, supervisorUserId) &&
        String(r.lob || 'ALL') === String(lobNorm) &&
        r.roleType === CargoOfRoleType.CSR_TYPE.code
      )
      if (exists) {
        return true
      }
      const supervisorForm = {
        seq: this.autoIncrementNum.getNextNum(),
        companyUuid: this.partner.uuid,
        roleType: CargoOfRoleType.CSR_TYPE.code,
        lob: lobNorm,
        userId: supervisorUserId,
        defaultUser: false,
        remarks: '',
        cargoSource: '',
        customerExpandMode: ''
      }
      const snapshot = [...this.rowData.map(r => ({ ...r })), { ...supervisorForm }]
      const supervisorOk = await this.checkCompanyUser(supervisorForm, snapshot)
      if (!supervisorOk) {
        return false
      }
      this.rowData.push(supervisorForm)
      return true
    },
    async query() {
      if (!this.partner.companyUsers) {
        this.partner.companyUsers = await Company.getCompanyUsers(this.partner.uuid)
      }
      for (const item of this.partner.companyUsers) {
        item.seq = this.autoIncrementNum.getNextNum()
      }
      if (!this.partner.deletedCompanyUserKeys) {
        this.partner.deletedCompanyUserKeys = []
      }
      this.rowData = this.partner.companyUsers
    },
    exportExcel() {
      const rows = []
      this.gridApi.forEachNode((node, index) => {
        rows.push(node.data)
      })
      const fileName = this.$t('Partners.batchChangeSales') + new Date().getTime().toString() + '.xls'
      const tHeader = []
      const filterVal = []
      // 对行中每列的值做处理
      for (const item of rows) {
        if (!item) continue
        for (const colDef of this.columnDefs) {
          const dataField = colDef.field
          if (!colDef.headerName || !dataField) continue
          if (!tHeader.includes(colDef.headerName) && !filterVal.includes(dataField)) {
            tHeader.push(colDef.headerName)
            filterVal.push(dataField)
          }
          let data = item.hasOwnProperty(dataField) ? item[dataField] : ''
          // 进行labelFunction 处理
          if (colDef.cellRenderer && typeof colDef.cellRenderer !== 'string') {
            const params = { data: item, value: item[dataField] }
            params.colDef = { field: colDef.field }
            data = colDef.cellRenderer(params)
          }
          if (data && typeof data === 'string') {
            data = StrUtils.replaceSpecialCharacter(data)
          }
          item[dataField] = data
        }
      }
      import('@/vendor/Export2Excel').then(excel => {
        const data = this.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: fileName
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    jobBussStateLabelFunc(value) {
      const state = SystemConstants.getCommonState(value, SystemConstants.FBA_LOBS)
      if (state == null) {
        return this.isZh ? this.$t('SeaExport.All') : 'All'
      }
      return this.isZh ? state.chineseName : state.englishName
    },
    roleTypeLabelFunc(value) {
      const roleType = CargoOfRoleType.getCargoOfRoleTypeByCode(value)
      if (roleType) {
        return this.isZh ? roleType.chineseName : roleType.englishName
      }
      return ''
    },
    // 验证输入（可选第二个参数 gridSnapshot：外挂逻辑里传入预拼装的全表快照后再校验，见 appendPartnerCsrSupervisorRow）
    async checkCompanyUser(form, gridSnapshot = null) {
      let roleType
      const userMap = {}
      if (!form.userId) {
        this.$message.warning(this.$t('Information.UserCannotBeEmpty'))
        return false
      }
      let user = this.$refs.userSelect && this.$refs.userSelect.options
        ? this.$refs.userSelect.options.find(row => this.samePartnerUserId(row.userId, form.userId))
        : null
      if (!user) {
        const label = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', form.userId, 'chineseName')
        user = { chineseName: label || String(form.userId), englishName: label || String(form.userId) }
      }
      if (form.roleType === 0) {
        this.$message.warning(this.$t('Partners.user') + '【' + user.chineseName + '】' + this.$t('Partners.positionTypeNotSelected'))
        return false
      }
      let rowData
      if (gridSnapshot != null) {
        rowData = gridSnapshot.map(r => ({ ...r }))
      } else {
        rowData = [...this.rowData]
        const selectedRowIndex = rowData.findIndex(p => p.seq === form.seq)
        if (selectedRowIndex >= 0) {
          rowData[selectedRowIndex] = form
        } else {
          rowData.push(form)
        }
      }
      const isSpecifiedSalesBusiness = Number(cache.config.get('IsSpecifiedSalesBusiness'))
      for (const row of rowData) {
        // CARGO-3576合作伙伴销售未勾选默认也要显示
        if (isSpecifiedSalesBusiness === 1) {
          roleType = form.roleType
          this.countDefalutCompanyUser(userMap, CargoOfRoleType.getCargoOfRoleTypeByCode(roleType).englishName, row)
        }
      }
      let num = 0
      for (const row of rowData) {
        if (row.userId === form.userId && row.lob === form.lob && row.roleType === form.roleType) {
          num += 1
        }
        if (num > 1) {
          this.$message.warning(this.$t('Partners.user') + '【' + user.chineseName + '】' + this.$t('Partners.multipleSameBusinessPosition'))
          return false
        }
      }
      if (form && isSpecifiedSalesBusiness === 1) {
        if (userMap['op'] && !this.validateDefalutCompanyUser(1, userMap['op'], rowData)) {
          return false
        }
        if (userMap['sales'] && !this.validateDefalutCompanyUser(2, userMap['sales'], rowData)) {
          return false
        }
        if (userMap['csr'] && !this.validateDefalutCompanyUser(3, userMap['csr'], rowData)) {
          return false
        }
        if (userMap['doc'] && !this.validateDefalutCompanyUser(4, userMap['doc'], rowData)) {
          return false
        }
        if (userMap['overseaOp'] && !this.validateDefalutCompanyUser(5, userMap['overseaOp'], rowData)) {
          return false
        }
        if (userMap['salesOfGoods'] && !this.validateDefalutCompanyUser(6, userMap['salesOfGoods'], rowData)) {
          return false
        }
        if (userMap['userDefinedRole1'] && !this.validateDefalutCompanyUser(7, userMap['userDefinedRole1'], rowData)) {
          return false
        }
        if (userMap['userDefinedRole2'] && !this.validateDefalutCompanyUser(8, userMap['userDefinedRole2'], rowData)) {
          return false
        }
        if (userMap['userDefinedRole3'] && !this.validateDefalutCompanyUser(13, userMap['userDefinedRole3'], rowData)) {
          return false
        }
        if (userMap['userDefinedRole4'] && !this.validateDefalutCompanyUser(14, userMap['userDefinedRole4'], rowData)) {
          return false
        }
        if (userMap['userDefinedRole5'] && !this.validateDefalutCompanyUser(15, userMap['userDefinedRole5'], rowData)) {
          return false
        }
        if (userMap['userDefinedRole6'] && !this.validateDefalutCompanyUser(16, userMap['userDefinedRole6'], rowData)) {
          return false
        }
        if (userMap['userDefinedRole7'] && !this.validateDefalutCompanyUser(17, userMap['userDefinedRole7'], rowData)) {
          return false
        }
      }
      return true
    },
    // 统计用户是否设置默认
    countDefalutCompanyUser(userMap, roleType, user) {
      const userType = userMap[roleType]
      let ids = []
      if (!userType) {
        const userCount = {}
        ids.push(user.userId)
        userCount['ids'] = ids
        userCount['defaultCount'] = !user.defaultUser ? 0 : 1
        userMap[roleType] = userCount
      } else {
        ids = userType['ids']
        ids.push(user.userId)
        userType['ids'] = ids
        if (user.defaultUser) {
          userType['defaultCount'] = userType['defaultCount'] + 1
        }
      }
    },
    // 验证是否有默认值 1一个类型用户自动补充默认，多个都没默认值，给出错误提示
    validateDefalutCompanyUser(type, userMap, companyUsers) {
      const ids = userMap['ids']
      const defaultCount = userMap['defaultCount']
      if (defaultCount === 0 && ids.length === 1) {
        for (var i = 0; i < companyUsers.length; i++) {
          if (type === companyUsers[i].roleType && ids[0] === companyUsers[i].userId) {
            companyUsers[i].defaultUser = true
          }
        }
      } else if (ids.length >= 0 && defaultCount <= 0) {
        const cargoOfRoleType = CargoOfRoleType.getCargoOfRoleTypeByCode(type)
        this.$message.info(cargoOfRoleType.chineseName + this.$t('Partners.defaultValueNotEmpty'))
        return false
      }
      return true
    },
    lobChange() {
      if (this.editDialog.form.lob !== 'SE') {
        this.editDialog.form.cargoSource = ''
      }
    },
    roleTypeChange() {
      if (this.editDialog.form.roleType === CargoOfRoleType.SALES_TYPE.code || this.editDialog.form.roleType === CargoOfRoleType.SALES_OF_GOODS.code) {
        this.editDialog.form.cargoSource = ''
      }
      if (this.editDialog.form.roleType !== CargoOfRoleType.SALES_TYPE.code) {
        this.editDialog.form.customerExpandMode = ''
      }
    },
    samePartnerUserId(a, b) {
      return String(a ?? '') === String(b ?? '')
    },
    userCustomLabel(user) {
      const name = this.$selectByLang(user.chineseName, user.englishName)
      let officeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', user.defaultOfficeId, 'code')
      if (officeCode) {
        officeCode = `【${officeCode}】`
      }
      return `${name}${officeCode}【${user.email}】`
    }
  }
}
</script>

<style>
</style>
